import { GENRE_SOURCE_MAP } from '@intelligence/components/GenreSelect/constants';

import type { IGenreSelectValue } from '@intelligence/components/GenreSelect/types';
import type { IRobloxTopChartsFilterValues } from './types';
import { ROBLOX_TOP_CHARTS_METRIC_VALUES } from './config/robloxTopChartsMetrics';

export const PAGE_ID = 'robloxTopCharts';
export const FILTER_SAVE_TYPE = 'roblox-top-charts';
export const ROBLOX_TOP_CHARTS_DEFAULT_PAGE_SIZE = 50;
export const ROBLOX_TOP_CHARTS_SEARCH_DROPDOWN_PAGE_SIZE = 20;
export const ROBLOX_TOP_CHARTS_DEFAULT_DATE_RANGE_DAYS = 30;
export const ROBLOX_TOP_CHARTS_DEFAULT_DATA_BY_DATE_PARAMS = {
  region_type: 'region',
  regions: ['global'],
  granularity: ['daily', 'weekly', 'monthly'],
  entity_type: 'roblox',
  source_metric: {
    roblox: ['roblox__pcu'],
  },
};
export const ROBLOX_TOP_CHARTS_DEFAULT_SELECT_GAME_NUM = 6;
export const ROBLOX_TOP_CHARTS_CHART_PAGE_SIZE = 100000;
export const ROBLOX_TOP_CHARTS_CHART_GROUP_BY = ['date', 'game_id'];

export const ROBLOX_TOP_CHARTS_DOWNLOAD_PAGE_SIZE = 5000;
export const ROBLOX_TOP_CHARTS_DOWNLOAD_USE_SSE_PAGE = {
  max_size: 100000,
};

export const ROBLOX_TOP_CHARTS_FIXED_FETCH_PARAMS = {
  group_by: ['game_id'],
  use_entity_type: 'roblox',
  use_custom_fields: [
    'entity_name',
    'cover',
    'roblox_genre',
    'roblox_sub_genre',
    'roblox_level_3_genre',
    'publisher',
    'release_time',
    'update_time',
    'support_feature',
  ],
  metrics: [...ROBLOX_TOP_CHARTS_METRIC_VALUES],
};

const getDefaultGenreValue = (): IGenreSelectValue => ({
  source: GENRE_SOURCE_MAP.ROBLOX,
  genres: [],
});

export const getDefaultFilterValues = (): IRobloxTopChartsFilterValues => {
  return {
    date: {
      granularity: 'daily',
      startDate: '',
      endDate: '',
    },
    releaseTime: {
      granularity: 'daily',
      startDate: '',
      endDate: '',
    },
    region: ['global'],
    genre: getDefaultGenreValue(),
  };
};
